<template>
  <div class="page-content conmon-top">
    <div class="base-input ovf-hd" style="margin-bottom: 10px;">
      <el-row class="search-title">
        <el-col :span="4" class="search-nav-left">
          <i class="el-icon-search" style="font-weight: bold;"></i>
          <span class="order-list-search-span">筛选查询</span>
        </el-col>
        <el-col :span="20" class="search-nav-right">
          <el-button class="search-open-close" type="text" @click="hide=!hide" v-show="hide">收起查询</el-button>
          <el-button class="search-open-close" type="text" @click="hide=!hide" v-show="!hide">展开查询</el-button>
          <i v-if="hide === true" class="el-icon-arrow-up search-open-close-i" @click="hide=!hide"></i>
          <i v-if="hide === false" class="el-icon-arrow-down search-open-close-i" @click="hide=!hide"></i>
          <el-button class="search-btn-new" type="primary" size="small" @click="searchLoad">查询</el-button>
        </el-col>
      </el-row>
      <el-collapse-transition>
        <div v-show="hide" class="search-content common-search-formtype">
          <el-form :inline="true" :model="formInlineTmp" label-width="95px" class="search-content-item">
            <el-form-item label="银行名称:">
              <el-input v-model.trim="formInlineTmp.bankname" placeholder="请输入银行名称" type="text" style="line-height: 60px;" clearable></el-input>
            </el-form-item>
            <el-form-item label="银行简称:">
              <el-input v-model.trim="formInlineTmp.banksub" placeholder="请输入银行简称" type="text" style="line-height: 60px;" clearable></el-input>
            </el-form-item>
          </el-form>
        </div>
      </el-collapse-transition>
    </div>
    <el-row class="search-title common-table-top" style="padding-right:0">
      <el-col :span="4" style="text-align: left;">
        <i class="el-icon-document" style="font-weight: bold;"></i>
        <span class="order-list-search-span">数据列表</span>
      </el-col>
      <el-col :span="20" class="text-align-right" style="">
        <el-button type="primary" @click="addDialog = true" class="add-btn" style="float: right;margin-right: 32px;">添加</el-button>
      </el-col>
    </el-row>
    <el-row class="import-data-title table-first-style">
      <el-table :data="tableData" v-loading="loading" class="table">
        <template slot="empty">
          <div class="newTableEmpty">暂无数据，去<span  @click="addDialog = true">新建</span></div>
        </template>
        <el-table-column label="ID" align="center" width="100">
          <template slot-scope="scope">
            {{ scope.row.id }}
          </template>
        </el-table-column>
        <el-table-column label="银行名称">
          <template slot-scope="scope">
            {{ scope.row.bankname }}
          </template>
        </el-table-column>
        <el-table-column label="简称">
          <template slot-scope="scope">
            {{ scope.row.banksub }}
          </template>
        </el-table-column>
        <el-table-column label="Logo">
          <template slot-scope="scope">
            <img :src="scope.row.logo | showImgUrl" style="width: 40px; height: 40px;" />
          </template>
        </el-table-column>
        <el-table-column label="创建时间" width="200">
          <template slot-scope="scope">
            {{ scope.row.create_time_text }}
          </template>
        </el-table-column>
        <el-table-column label="修改时间" width="200">
          <template slot-scope="scope">
            {{ scope.row.update_time_text }}
          </template>
        </el-table-column>
        <el-table-column label="操作" width="260">
          <template slot-scope="scope">
            <div class="op-link editColor" @click="editAction(scope.row.id)">
              编辑
            </div>
            <div class="op-link deleteColor" @click="deleteAction(scope.row.id)">
              删除
            </div>
          </template>
        </el-table-column>
      </el-table>
      <div class="table-foot">
        <el-pagination class="table-foot-pagination" background @size-change="handleSizeChange" @current-change="handleCurrentChange" :page-size="limit" layout="total, prev, pager, next, jumper" :total="totalCount">
        </el-pagination>
      </div>

      <el-dialog class="cellDialog base-dialog" title="添加帮助信息" :visible.sync="addDialog" width="550px">
        <el-form :model="addForm" label-width="110px" ref="addForm" :rules="rules">
          <el-form-item label="银行名称" prop="bankname">
            <el-input v-model="addForm.bankname" placeholder="请输入银行名称" maxlength="30"></el-input>
          </el-form-item>
          <el-form-item label="银行简称" prop="banksub">
            <el-input v-model="addForm.banksub" placeholder="请输入银行简称" maxlength="20"></el-input>
          </el-form-item>
          <el-form-item label="列表缩略图：" style="height: 160px;">
            <el-upload class="avatar-uploader" name="file_upload"
                       :action="uploadURL"
                       :show-file-list="false"
                       :on-success="(res, file) => { return handleInterfaceSuccess(res, file, 'logo')}"
                       :before-upload="beforeAvatarUpload">
              <img v-if="addForm.logo" :src="addForm.logo" style="width: 120px; height: 120px; display: block;">
              <i v-else class="el-icon-plus avatar-uploader-icon"></i>
            </el-upload>
            <p class="interface_update_p" style="width: 400px;">建议尺寸200px*200px，大小200kb以内，格式为jpg,png
            </p>
          </el-form-item>
        </el-form>
        <div slot="footer" class="dialog-footer">
          <el-button class="dialog-cancel-btn" @click="closeAddDialogAction">取 消</el-button>
          <el-button class="dialog-confirm-btn" style="margin-right: 32px" type="primary" @click="submitForm('addForm')">确 定</el-button>
        </div>
      </el-dialog>
      <el-dialog class="cellDialog base-dialog" title="修改帮助信息" :visible.sync="editDialog" width="550px">
        <el-form :model="editForm" label-width="110px"  ref="editForm" :rules="rules" >
          <el-form-item label="银行名称" prop="bankname">
            <el-input v-model="editForm.bankname" placeholder="请输入银行名称" maxlength="30"></el-input>
          </el-form-item>
          <el-form-item label="银行简称" prop="banksub">
            <el-input v-model="editForm.banksub" placeholder="请输入银行简称" maxlength="20"></el-input>
          </el-form-item>
          <el-form-item label="列表缩略图：" style="height: 160px;">
            <el-upload class="avatar-uploader" name="file_upload"
                       :action="uploadURL"
                       :show-file-list="false"
                       :on-success="(res, file) => { return handleInterfaceSuccess(res, file, 'editlogo')}"
                       :before-upload="beforeAvatarUpload">
              <img v-if="editForm.logo" :src="editForm.logo" style="width: 120px; height: 120px; display: block;">
              <i v-else class="el-icon-plus avatar-uploader-icon"></i>
            </el-upload>
            <p class="interface_update_p" style="width: 400px;">建议尺寸200px*200px，大小200kb以内，格式为jpg,png
            </p>
          </el-form-item>
        </el-form>
        <div slot="footer" class="dialog-footer">
          <el-button class="dialog-cancel-btn" @click="editDialog = false">取 消</el-button>
          <el-button class="dialog-confirm-btn" style="margin-right: 32px" type="primary" @click="submitconfirmForm('editForm')">确 定</el-button>
        </div>
      </el-dialog>
    </el-row>
  </div>
</template>
<script>
import { API_HOST } from '@/api/local'
import { getYxBank, deleteYxBank, createYxBank, getYxBankDetail, editYxBank } from '@/api/yunxiao.js'
export default {
  name: 'list',
  data () {
    return {
      loading: true,
      formInlineTmp:{},
      formInline: {
        bankname: '',
        banksub: ''
      },
      options: [],
      hide: true,
      tableData: [],
      page: 1,
      totalCount: 0,
      limit: 10,
      addForm: {
        bankname: '',
        banksub: '',
        logo: ''
      },
      editForm: {
        bankname: '',
        banksub: '',
        logo: ''
      },
      editId: '',
      editDialog: false,
      addDialog: false,
      rules: {
        bankname: [
          { required: true, message: '请输入银行名称', trigger: 'blur' }
        ],
        banksub: [
          { required: true, message: '请输入银行简称', trigger: 'blur' }
        ]
      }
    }
  },
  methods: {
    searchLoad() {
      this.page = 1
      this.formInline = JSON.parse(JSON.stringify(this.formInlineTmp))
      this.getData()
    },
    // 处理分页
    handleSizeChange(val) {
      this.limit = val
    },
    handleCurrentChange(page) {
      this.page = page
      this.getData()
    },
    getData() {
      this.loading = true
      getYxBank(this.page, this.formInline).then(res => {
        this.tableData = res.data.data.list
        this.totalCount = res.data.data.count
      })
      this.openLoading()
    },
    // 数据加载时的动画
    openLoading() {
      setTimeout(() => {
        this.loading = false
      }, 500)
    },
    closeAddDialogAction() {
      this.addDialog = false
      this.resetForm()
    },
    submitForm(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.addAction()
        } else {
          return false
        }
      })
    },
    // 请求详情
    editAction(id) {
      this.editDialog = true
      this.editId = id
      getYxBankDetail(id).then(res => {
        if(res.data.code === 0){
          this.editForm = res.data.data
        }
        else{
          this.editForm = {
            bankname: '',
            banksub: '',
            logo: ''
          }
        }
      })
    },
    submitconfirmForm(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.confirmAction()
        } else {
          return false
        }
      })
    },
    // 修改
    confirmAction() {
      editYxBank(this.editId, this.editForm).then(res => {
        if (res.data.code === 0) {
          _g.toastMsg('success', res.data.error)
          this.editDialog = false
          this.getData()
        } else {
          _g.toastMsg('error', res.data.error)
        }
      })
    },
    // 添加
    addAction() {
      createYxBank(this.addForm).then(res => {
        if (res.data.code === 0) {
          this.addDialog = false
          _g.toastMsg('success', res.data.error)
          this.getData()
          this.resetForm()
        } else {
          _g.toastMsg('error', res.data.error)
        }
      })
    },
    resetForm() {
      this.addForm = {
        bankname: '',
        banksub: '',
        logo: ''
      }
    },
    // 删除
    deleteAction(id) {
      this.$confirm('确认删除该信息吗?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        deleteYxBank(id).then((res) => {
          if (res.data.code === 0) {
            this.getData()
            _g.toastMsg('success', '删除成功')
          } else {
            _g.toastMsg('error', res.data.error)
          }
        })
      }).catch((error) => {
        console.log(error)
      })
    },
    beforeAvatarUpload(file) {
      const isJPG = file.type === 'image/jpeg'
      const isPNG = file.type === 'image/png'
      const isLt2M = file.size / 1024 / 1024 < 1
      if (!isJPG && !isPNG) {
        _g.toastMsg('error', '上传头像图片只能是 JPG/PNG 格式!')
      }
      if (!isLt2M) {
        _g.toastMsg('error', '上传活动图片大小不能超过 1MB!')
      }
      const check = (isJPG && isLt2M) || (isPNG && isLt2M)
      if (check) {
        _g.toastMsg('success', '正在上传')
      }
      return check
    },
    handleInterfaceSuccess(res, file, index) {
      if (res.code != 0) {
        _g.toastMsg('error', res.error)
      }
      if (index === 'logo') {
        this.addForm.logo = res.data.path
      }
      if (index === 'editlogo') {
        this.editForm.logo = res.data.path
      }
      _g.toastMsg('success', '上传成功')
    },
  },
  created() {
    this.getData()
  },
  computed: {
    uploadURL() {
      return API_HOST + '/admin/Upload/upload'
    }
  },
  components: {
  }
}
</script>

<style scoped>
.avatar-uploader .el-upload {
  border: 1px dashed #d9d9d9;
  border-radius: 6px;
  cursor: pointer;
  position: relative;
  overflow: hidden;
}
.avatar-uploader .el-upload:hover {
  border-color: #409EFF;
}
.avatar-uploader-icon {
  font-size: 28px;
  color: #8c939d;
  width: 120px;
  height: 120px;
  line-height: 120px;
  text-align: center;
  border: 1px dashed #d9d9d9;
  border-radius: 6px;
}
</style>
